import React from 'react'
import FullDashboardPersonalizedComponent from '../Components/app/dashboard/dashboard-personalization/FullDashboardPersonalizedComponent';


function FullDashboardPersonalized() {
  return  <FullDashboardPersonalizedComponent/>
}


export default FullDashboardPersonalized;